<template>
	<div>
		<div class="modal fade" id="mdTipProp">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" id="myModalLabel">
							Tipo de propostas
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-3">
							<span>Código</span>
							<input
								type="text"
								v-model="data.cod"
								disabled
								class="form-control"
							/>
						</div>
						<div class="clearfix"></div>
						<br />

						<div class="col-sm-9">
							<span>Tipo de proposta</span>
							<input
								type="text"
								v-model="data.titulo"
								class="form-control"
							/>
						</div>

						<div class="col-sm-3">
							<span>Cálculado por</span>
							<select v-model="data.calculo" class="form-control">
								<option value="mes">Mês</option>
								<option value="ano">Ano</option>
								<option value="vida">Vida</option>
							</select>
						</div>

						<div class="clearfix"></div>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-default"
							data-dismiss="modal"
						>
							<i class="fa fa-close"></i> Cancelar
						</button>
						<aBtn
							action="private-save-types_of_proposals"
							@click="save"
							text="Salvar"
							icon="save"
							type="primary"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import clone from 'js/clone';
	import aBox from 'box';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';
	let reset = { titulo: '', calculo: 'mes' };

	export default {
		name: 'ChModalCategorias',
		components: { aBox, aBtn },
		data() {
			return {
				data: clone(reset),
			};
		},
		methods: {
			open(data = null) {
				if (data != null) this.data = clone(data);
				else this.data = clone(reset);
				$('#mdTipProp').modal('show');
			},
			save() {
				WBS.send(
					'private-save-types_of_proposals',
					this.data,
					(resp) => {
						if (resp.status == 'success') {
							toastr.success('Registro alterado com sucesso!');
							this.$emit('update');
							$('#mdTipProp').modal('hide');
						} else {
							toastr.error(resp.msgs[0]);
							console.log(resp);
						}
					}
				);
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/types-of-proposals/modal.vue